import LoadingBar from './src/loading-bar';

module.exports = LoadingBar;


// WEBPACK FOOTER //
// ./src/components/loading-bar/index.js